var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { columns } from "./column/column";
import { getAONStaffAccounts } from "../../../api/marketData/AonStaff";
import { AonButton } from "../../../components/core/AonButton";
import { BUTTON_VARIANT } from "../../../components/core/AonButton/consts";
import { AddAndUpdateAonStaffDialog } from "../../Dailog/AddAndUpdateAonStaffDialog";
import "./AonStaffContent.scss";
import { handleAONStaffCrud } from "../../../api/marketData/AllStaffCrud";
import { useClientPageStore, useErrorStore } from "../../../store";
import { getOktaUserEmail } from "../../../api/auth/okta";
import ConfirmationDailog from "../../Dailog/RemoveClientConf";
import { useNavigate } from "react-router-dom";
import AonAgGridTable from "../../../components/core/AonAgGridTable/table";
export var AOnStaffContent = function (props) {
    var _a = useState([]), AONListAccounts = _a[0], SetAONListAccounts = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), addDailog = _c[0], setAddDailog = _c[1];
    var clientStore = useClientPageStore();
    var _d = useState(false), showConfirmation = _d[0], setShowConfirmation = _d[1];
    var _e = useState({ showDailog: false, index: NaN }), requestDeleteConfirmation = _e[0], SetrequestDeleteConfirmation = _e[1];
    var navigation = useNavigate();
    var errorStore = useErrorStore();
    var _f = React.useState({
        currentPage: 1,
        totalDatacount: undefined,
        pagesize: 100,
        year: "",
        searchText: "",
        sortColumn: "marketTypeName",
        sortBy: "DESC"
    }), pageConfig = _f[0], setPageConfig = _f[1];
    useEffect(function () {
        if (props.selectedClientGuuid && props.activeTab === 3) {
            fetchData();
        }
    }, [props.activeTab, props.selectedClientGuuid, pageConfig.currentPage, pageConfig.pagesize, pageConfig.year]);
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var AOnStaffContent_1, _clientListAccount, totalCount_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, getAONStaffAccounts({ ClientGuid: props.selectedClientGuuid, Page: pageConfig.currentPage, PageSize: pageConfig.pagesize })];
                case 1:
                    AOnStaffContent_1 = _a.sent();
                    _clientListAccount = AOnStaffContent_1.data.value.map(function (item) { return (__assign(__assign({}, item), { selected: true })); });
                    totalCount_1 = AOnStaffContent_1.headers["x-total-count"];
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { totalDatacount: totalCount_1 })); }); //settting up the total data count;
                    SetAONListAccounts(_clientListAccount);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.log("error from AON staff Page" + error_1);
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handlePageChangeRequest = function (page) {
        page = page.detail.page;
        setPageConfig(function (prev) {
            return (__assign(__assign({}, prev), { currentPage: page }));
        });
    };
    var onRowEventTrigger = function (index, isEdit) { return __awaiter(void 0, void 0, void 0, function () {
        var rowData, res, userEmail, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rowData = AONListAccounts[index];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    if (!isEdit) return [3 /*break*/, 2];
                    //need to check
                    clientStore.setSelectedAonStaffAccount(rowData);
                    setAddDailog(true);
                    return [3 /*break*/, 4];
                case 2:
                    clientStore.setSelectedAonStaffAccount(null);
                    return [4 /*yield*/, handleAONStaffCrud([{
                                "clientGuid": rowData.clientGuid,
                                "accountGuid": rowData.accountGuid,
                                "associateColleagueTypeId": rowData.associatedColleagueTypeId,
                                "changeComment": "Changed by colleague in MarketPreView",
                                "addColleague": {
                                    "email": rowData.colleagueEmail,
                                    "displayName": rowData.colleagueDisplayName,
                                    "identityProviderID": 2,
                                    "idFromProvider": "",
                                },
                                "addDeleteUpdate": 2
                            }])];
                case 3:
                    res = _a.sent();
                    userEmail = getOktaUserEmail();
                    if (rowData.colleagueEmail === userEmail) {
                        clientStore.setShowClientFeature(false);
                    }
                    _a.label = 4;
                case 4:
                    setIsLoading(true);
                    return [4 /*yield*/, fetchData()];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 6:
                    error_2 = _a.sent();
                    console.log("error from AON staff Page" + error_2);
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 8];
                case 7:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    function onClickAdd() {
        clientStore.setSelectedAonStaffAccount(null);
        setAddDailog(!addDailog);
    }
    var onClickSelected = function (event, index) {
        event.preventDefault();
        var _aonStaffList = __spreadArray([], AONListAccounts, true);
        _aonStaffList[index].selected = !_aonStaffList[index].selected;
        SetAONListAccounts(_aonStaffList);
    };
    var removeSelectedRows = function () { return __awaiter(void 0, void 0, void 0, function () {
        var rowDataList, requestBody_1, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rowDataList = AONListAccounts.filter(function (item) { return !item.selected; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    requestBody_1 = [];
                    rowDataList.forEach(function (rowData) {
                        requestBody_1.push({
                            "clientGuid": rowData.clientGuid,
                            "accountGuid": rowData.accountGuid,
                            "associateColleagueTypeId": rowData.associatedColleagueTypeId,
                            "changeComment": "Changed by colleague in MarketPreView",
                            "addColleague": {
                                "email": rowData.colleagueEmail,
                                "displayName": rowData.colleagueDisplayName,
                                "identityProviderID": 2,
                                "idFromProvider": "",
                            },
                            "addDeleteUpdate": 2
                        });
                    }, []);
                    return [4 /*yield*/, handleAONStaffCrud(requestBody_1)];
                case 2:
                    _a.sent();
                    setShowConfirmation(false);
                    setIsLoading(true);
                    return [4 /*yield*/, fetchData()];
                case 3:
                    _a.sent();
                    setIsLoading(false);
                    return [3 /*break*/, 6];
                case 4:
                    error_3 = _a.sent();
                    console.log("error from AON staff Page" + error_3);
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 6];
                case 5:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var isRemovedEnabled = clientStore.isUserHaveFullAccess && AONListAccounts.filter(function (item) { return !item.selected; }).length > 0;
    var _g = useState(window.innerHeight), currentInneHeight = _g[0], setcurrentInneHeight = _g[1];
    useEffect(function () {
        var updateSize = function () {
            var innerHeight = window.innerHeight;
            setcurrentInneHeight(innerHeight);
        };
        window.addEventListener("resize", updateSize);
        return function () {
            window.removeEventListener("resize", updateSize);
        };
    }, []);
    var rowDeletionDenia = function () {
        SetrequestDeleteConfirmation({
            showDailog: false,
            index: NaN
        });
    };
    var removeRow = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoading(true);
                    if (!!isNaN(requestDeleteConfirmation.index)) return [3 /*break*/, 2];
                    return [4 /*yield*/, onRowEventTrigger(requestDeleteConfirmation.index, false)];
                case 1:
                    _a.sent();
                    SetrequestDeleteConfirmation({ index: NaN, showDailog: false });
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    error_4 = _a.sent();
                    console.log("error from AON staff Page" + error_4);
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleColumnSorting = function (sortColumn) {
        var revertSortBy = function (sBy) { return sBy === "DESC" ? "ASC" : "DESC"; };
        if (sortColumn === pageConfig.sortColumn) {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: revertSortBy(pageConfig.sortBy) }));
            });
        }
        else {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: "DESC" }));
            });
        }
        var tempData = __spreadArray([], AONListAccounts, true);
        var reverseSort = revertSortBy(pageConfig.sortBy);
        tempData = tempData.sort(function (a, b) {
            if (a[sortColumn] < b[sortColumn]) {
                return reverseSort === "ASC" ? +1 : -1;
            }
            else if (a[sortColumn] > b[sortColumn]) {
                return reverseSort === "ASC" ? -1 : +1;
            }
            else
                return 0;
        });
        SetAONListAccounts(__spreadArray([], tempData, true));
    };
    return (React.createElement("div", { className: "client-list-box" },
        React.createElement("div", { className: "addFilter" },
            React.createElement(AonButton, { disabled: !clientStore.isUserHaveFullAccess, style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return onClickAdd(); } }, "Add"),
            React.createElement(AonButton, { disabled: !isRemovedEnabled, style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return setShowConfirmation(true); } }, "Remove")),
        React.createElement("div", { className: "spacer" },
            React.createElement(AonAgGridTable, { rowData: AONListAccounts, height: currentInneHeight, columns: columns(onClickSelected, pageConfig.sortBy, pageConfig.sortColumn, handleColumnSorting, isLoading, function (index, isEdit) { isEdit ? onRowEventTrigger(index, isEdit) : SetrequestDeleteConfirmation({ index: index, showDailog: true }); }), loading: isLoading, pagination: true, currentPage: pageConfig.currentPage, totalCount: pageConfig.totalDatacount, pageSize: pageConfig.pagesize, onPageChange: handlePageChangeRequest })),
        addDailog && React.createElement(AddAndUpdateAonStaffDialog, { addDailog: true, refressPage: function () {
                setAddDailog(false);
                fetchData();
            }, clientGuid: props.selectedClientGuuid, onClickClose: function () { return setAddDailog(false); } }),
        showConfirmation && React.createElement(ConfirmationDailog, { loader: isLoading, onDenie: function () { return setShowConfirmation(false); }, onConfirm: function () { return removeSelectedRows(); }, showDialog: true }),
        requestDeleteConfirmation.showDailog && React.createElement(ConfirmationDailog, { loader: isLoading, onDenie: function () { return rowDeletionDenia(); }, onConfirm: function () { return removeRow(); }, showDialog: true })));
};
